"use client";

import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import { CalendarClock, Info, MapPin } from "lucide-react";

const LINKS = [
    { label: "درباره ما", href: "/fa/about-us", icon: Info, target: "_self" },
    { label: "مسیریابی به فروشگاه", href: "geo:35.726363, 51.322396", icon: MapPin, target: "_self" },
    { label: "رزرو وقت بینایی سنجی", href: "https://eynakology.com/", icon: CalendarClock, target: "_blank" },
];

const INTERVAL = 4000;

export default function TopBarMobileLinks() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setInterval(() => {
            setVisible(false);
            setTimeout(() => {
                setActiveIndex((prev) => (prev + 1) % LINKS.length);
                setVisible(true);
            }, 300);
        }, INTERVAL);
        return () => clearInterval(timer);
    }, []);

    const link = LINKS[activeIndex];
    const Icon = link.icon;

    return (
        <Box
            sx={{
                display: { xs: "flex", md: "none" },
                alignItems: "center",
                overflow: "hidden",
            }}
        >
            <Box
                component="a"
                href={link.href}
                target={link.target}
                sx={{
                    color: "#bbb",
                    fontSize: 12,
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    opacity: visible ? 1 : 0,
                    transition: "opacity 0.3s ease",
                    whiteSpace: "nowrap",
                    "&:hover": { color: "#fff" },
                }}
            >
                <Icon size={12} color="#fff" />
                {link.label}
            </Box>
        </Box>
    );
}
